import Component from '../../common/Component';
import app from '../app';
export default class PostType extends Component {
  view() {
    const post = this.attrs.post;
    const PostComponent = app.postComponents[post.contentType()];
    return !!PostComponent && m(PostComponent, {
      post: post
    });
  }
}
flarum.reg.add('core', 'forum/components/PostType', PostType);